// src/store/slices/ticketLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ticketLogApi from 'api/ticketLogApi';

export const fetchTicketLogs = createAsyncThunk(
  'ticketLog/fetchAll',
  async ({ page = 1, pageSize = 20, search = '', ticket = '' }, { rejectWithValue }) => {
    try {
      const res = await ticketLogApi.getAll(page, pageSize, search, ticket);
      return res;
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || 'Failed to load ticket logs');
    }
  }
);

const ticketLogSlice = createSlice({
  name: 'ticketLog',
  initialState: {
    logs: [],
    pagination: { count: 0, page_size: 20 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTicketLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTicketLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        state.pagination = action.payload.pagination || { count: 0, page_size: 20 };
      })
      .addCase(fetchTicketLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = ticketLogSlice.actions;
export default ticketLogSlice.reducer;